window.am = window.am || {};

window.am.ajax = new function () {
    /// <summary>
    /// Holds all methods which have to do with ajax calls.
    /// </summary>
    var that = this;

    that.sendRequest = function (
        url,
        method,
        successCallback,
        errorCallback,
        optionalPostBody,
        rawResponse,
        decorateRequest) {
        /// <summary>
        /// Sends the ajax request defined by the passed params.
        /// </summary>
        /// <param name="url">
        /// The url where the call should be sent to.
        /// </param>
        /// <param name="method">
        /// The method which should be used. (GET, POST)
        /// </param>
        /// <param name="successCallback">
        /// The function which should be called if the ajax call is successful.
        /// </param>
        /// <param name="errorCallback">
        /// The function which should be called if something go wrong with 
        /// the ajax call.
        /// </param>
        /// <param name="optionalPostBody">
        /// (Optional) The content which should be posted.
        /// </param>
        var request = new XMLHttpRequest();

        request.open(method, url);

        request.setRequestHeader(
            'X-Requested-With', 'XMLHttpRequest');

        request.setRequestHeader(
            'Content-Type', 'application/json');

        if (decorateRequest) {
            decorateRequest(request);
        }

        request.onreadystatechange = function () {
            if (request.readyState === 4) {
                if (request.status < 200 || request.status > 299) {
                    if (errorCallback) {
                        errorCallback(request.status, request.responseText);
                    }
                }
                else {
                    var response = request.responseText;

                    if (!(rawResponse === true || response === '')) {
                        response = JSON.parse(response);
                    }

                    if (successCallback) {
                        successCallback(response);
                    }
                }
            }
        };

        if (optionalPostBody) {
            request.send(optionalPostBody);
        }
        else {
            request.send();
        }

        return true;
    };
};